var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Interaction field") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.71707286,1.14680851 C3.19111114,1.14680851 1.14341457,3.20058315 1.14341457,5.73404255 L1.14341457,18.3489362 C1.14341457,20.8823956 3.19111114,22.9361702 5.71707286,22.9361702 L18.8663404,22.9361702 C21.3923022,22.9361702 23.4399987,20.8823956 23.4399987,18.3489362 L23.4399987,5.73404255 C23.4399987,3.20058315 21.3923022,1.14680851 18.8663404,1.14680851 L5.71707286,1.14680851 Z M5.71707286,0 L18.8663404,0 C22.0237926,-5.09285285e-16 24.5834133,2.5672183 24.5834133,5.73404255 L24.5834133,18.3489362 C24.5834133,21.5157604 22.0237926,24.0829787 18.8663404,24.0829787 L5.71707286,24.0829787 C2.55962071,24.0829787 5.07778074e-16,21.5157604 0,18.3489362 L1.01555615e-15,5.73404255 C5.07778074e-16,2.5672183 2.55962071,5.09285285e-16 5.71707286,0 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.17170465,0 C1.57447812,0 2.19694621,0.509648118 2.19694621,0.910085925 L1.83078851,9.28287643 C1.83078851,9.68331424 1.50124658,10.0109452 1.09847311,10.0109452 C0.695699634,10.0109452 0.366157702,9.68331424 0.366157702,9.28287643 L0.183078851,0.946489362 C0.183078851,0.546051555 0.805546945,0 1.17170465,0 Z M1.09847311,11.831117 C1.7209412,11.831117 2.19694621,12.3043617 2.19694621,12.9232201 C2.19694621,13.5420786 1.7209412,14.0153232 1.09847311,14.0153232 C0.476005013,14.0153232 0,13.5420786 0,12.9232201 C0,12.3043617 0.476005013,11.831117 1.09847311,11.831117 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Inbox---chating-profile-1",
    transform: "translate(-29.000000, -554.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Interaction-field",
    transform: "translate(29.000000, 554.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Messages"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey-copy",
    transform: "translate(0.152622, 0.208511)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#979797",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    fill: "#646464",
    id: "colour/dark-grey"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.715122, -2.293617)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 28.5853643,
    height: 28.6702128
  })))), /*#__PURE__*/React.createElement("g", {
    id: "colour/dark-grey",
    transform: "translate(11.586768, 5.369149)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-4)",
    fill: "#646464"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13.149268, -7.454255)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 28.5853643,
    height: 28.6702128
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReport);
export default __webpack_public_path__ + "static/media/icReport.6d4c19a57af314cb8eab667cbdfa6134.svg";
export { ForwardRef as ReactComponent };